function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "16.413 198.511 128.186 125.878",
    height: 28,
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 137.869 215.219 L 112.149 200.439 C 107.014 197.472 101.648 198.118 96.512 201.085 C 96.512 201.085 25.292 249.436 20.487 253.026 C 20.089 252.888 16.839 257.682 17.237 257.82 C 16.808 257.755 16.22 263.501 16.475 263.54 C 16.475 263.54 16.429 297.119 16.709 297.939 C 17.141 299.208 17.821 300.377 18.709 301.379 L 18.789 301.459 C 18.915 301.607 19.048 301.747 19.189 301.879 C 19.497 302.204 19.832 302.501 20.189 302.769 C 20.54 303.043 20.911 303.291 21.299 303.509 L 55.149 323.009 C 56.532 323.912 58.148 324.391 59.799 324.389 C 61.719 324.389 63.369 323.239 65.019 322.229 L 65.569 321.889 L 69.629 319.399 C 71.729 320.549 74.629 320.399 77.769 318.529 C 83.409 315.279 88.089 307.939 89.129 301.209 L 107.569 290.219 C 109.879 291.569 111.899 292.749 112.829 293.279 C 114.939 294.479 117.829 294.279 121.049 292.449 C 126.449 289.329 130.959 282.449 132.249 275.999 L 138.469 272.579 L 138.599 272.499 C 142.334 270.133 144.598 266.02 144.599 261.599 L 144.599 226.839 C 144.594 222.041 142.029 217.611 137.869 215.219 Z",
    style: {
      fill: "#003173"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 138.139 227.566 L 129.169 233.985 C 127.81 234.805 127.366 236.881 127.366 238.468 L 127.206 251.198 C 127.216 252.733 128.786 253.207 130.114 252.44 L 139.229 245.564 C 140.692 244.628 140.828 243.661 140.829 241.924 L 140.969 229.126 C 140.976 227.71 139.447 226.817 138.217 227.519 C 138.191 227.534 138.165 227.55 138.139 227.566 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 122.034 238.761 L 113.064 245.18 C 111.705 246 111.261 248.076 111.261 249.663 L 111.101 262.393 C 111.111 263.928 112.681 264.402 114.009 263.635 L 123.124 256.759 C 124.587 255.823 124.723 254.856 124.724 253.119 L 124.864 240.321 C 124.871 238.905 123.342 238.012 122.112 238.714 C 122.086 238.729 122.06 238.745 122.034 238.761 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 105.66 249.668 L 96.69 256.087 C 95.331 256.907 94.887 258.983 94.887 260.57 L 94.727 273.3 C 94.737 274.835 96.307 275.309 97.635 274.542 L 106.75 267.666 C 108.213 266.73 108.349 265.763 108.35 264.026 L 108.49 251.228 C 108.497 249.812 106.968 248.919 105.738 249.621 C 105.712 249.636 105.686 249.652 105.66 249.668 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.107 260.679 L 80.137 267.098 C 78.778 267.918 78.334 269.994 78.334 271.581 L 78.174 284.311 C 78.184 285.846 79.754 286.32 81.082 285.553 L 90.197 278.677 C 91.66 277.741 91.796 276.774 91.797 275.037 L 91.937 262.239 C 91.944 260.823 90.415 259.93 89.185 260.632 C 89.159 260.647 89.133 260.663 89.107 260.679 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 72.961 271.396 L 63.991 277.815 C 62.632 278.635 62.188 280.711 62.188 282.298 L 62.321 300.18 C 62.331 301.715 63.846 303.146 65.174 302.379 L 74.129 296.439 C 75.592 295.503 75.617 294.588 75.618 292.851 L 75.791 272.956 C 75.798 271.54 74.269 270.647 73.039 271.349 C 73.013 271.364 72.987 271.38 72.961 271.396 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.338 278.118 L 23.655 262.043 C 21.463 261.69 20.336 263.07 20.043 264.986 L 19.998 281.627 C 20.116 284.081 20.142 284.173 22.325 285.951 L 54.081 303.383 C 55.635 304.146 57.293 302.055 57.326 300.5 L 57.273 282.157 C 57.297 280.851 56.648 279.168 55.338 278.118 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.728 299.258 C 19.27 298.986 18.944 297.614 19.163 296.544 C 19.382 295.474 20.334 294.501 21.705 294.665 C 22.973 295.081 23.523 295.628 23.329 297.129 C 23.135 298.635 22.002 299.496 20.728 299.258 Z",
    style: {
      fill: "rgb(145, 197, 237)"
    },
    transform: "matrix(-1, 0, 0, -1, 42.468121, 593.944092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.406 317.836 C 51.948 317.564 51.622 316.192 51.841 315.122 C 52.06 314.052 53.012 313.079 54.383 313.243 C 55.651 313.659 56.201 314.206 56.007 315.707 C 55.813 317.213 54.68 318.074 53.406 317.836 Z",
    style: {
      fill: "rgb(145, 197, 237)"
    },
    transform: "matrix(-1, 0, 0, -1, 107.82412, 631.100098)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.151 314.038 C 47.379 313.764 47.291 312.007 47.343 311.649 L 45.977 310.905 L 27.02 299.961 L 27.02 301.421 C 27.022 301.783 27.051 302.144 27.105 302.501 C 27.134 302.587 27.171 302.669 27.218 302.745 C 27.263 302.823 27.313 302.896 27.371 302.966 C 27.39 302.988 27.411 303.009 27.433 303.028 C 27.475 303.071 27.52 303.11 27.569 303.147 C 27.618 303.184 27.668 303.219 27.722 303.249 L 46.735 314.249 C 47.045 314.157 46.924 314.312 47.151 314.038 Z",
    style: {
      fill: "rgb(145, 197, 237)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 120.994 272.091 C 116.959 274.707 114.423 279.099 114.174 283.901 C 114.174 288.241 117.254 290.001 121.034 287.811 C 125.058 285.204 127.593 280.829 127.854 276.041 C 127.844 271.661 124.744 269.911 120.994 272.091 Z M 123.794 278.351 C 123.685 280.3 122.657 282.082 121.024 283.151 C 119.484 284.041 118.234 283.331 118.234 281.561 C 118.329 279.608 119.361 277.821 121.004 276.761 C 122.544 275.871 123.744 276.581 123.794 278.351 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.081 298.752 C 74.046 301.368 71.51 305.76 71.261 310.562 C 71.261 314.902 74.341 316.662 78.121 314.472 C 82.145 311.865 84.68 307.49 84.941 302.702 C 84.931 298.322 81.831 296.572 78.081 298.752 Z M 80.881 305.012 C 80.772 306.961 79.744 308.743 78.111 309.812 C 76.571 310.702 75.321 309.992 75.321 308.222 C 75.416 306.269 76.448 304.482 78.091 303.422 C 79.631 302.532 80.831 303.242 80.881 305.012 Z",
    style: {
      fill: "#91c5ed"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusMap);
export default __webpack_public_path__ + "static/media/bus_map.89e95ed03aec46bd9ec35c9547a3e3ab.svg";
export { ForwardRef as ReactComponent };